import { render, staticRenderFns } from "./BaseHead.vue?vue&type=template&id=132e8474&"
import script from "./BaseHead.vue?vue&type=script&lang=js&"
export * from "./BaseHead.vue?vue&type=script&lang=js&"
import style0 from "./BaseHead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports